'use client';
import { useState } from 'react';
import { useRouter } from 'next/navigation';
import useSEO from '../hooks/useSEO';
import Button from '../components/Button';

function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const router = useRouter();

    useSEO('تسجيل الدخول - لوحة التحكم', 'صفحة دخول المسؤولين', 'login, admin');

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');

        try {
            const response = await fetch('/api/auth/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password }),
            });

            const data = await response.json();

            if (data.success) {
                // In a real app, store token in localStorage/Context
                localStorage.setItem('user', JSON.stringify(data.user));
                localStorage.setItem('token', data.token);
                // alert('Login successful! Welcome ' + data.user.username);
                router.push('/dashboard'); // Redirect to Admin Dashboard
            } else {
                setError(data.message || 'Login failed');
            }
        } catch (err) {
            setError('An error occurred during login');
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 text-right" dir="rtl">
            <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md border border-gray-100">
                <h2 className="text-2xl font-bold text-primary mb-6 text-center">تسجيل الدخول</h2>

                {error && <div className="bg-red-50 text-red-600 p-3 rounded mb-4 text-sm">{error}</div>}

                <form onSubmit={handleLogin} className="space-y-4">
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2">اسم المستخدم</label>
                        <input
                            type="text"
                            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:border-primary transition-colors"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2">كلمة المرور</label>
                        <input
                            type="password"
                            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:border-primary transition-colors"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <Button type="submit" variant="primary" className="w-full bg-primary text-white py-2 rounded-lg font-bold hover:bg-opacity-90 transition-all">
                        دخول
                    </Button>
                </form>
                <div className="mt-4 text-center">
                    <a href="/" className="text-sm text-gray-500 hover:text-primary">العودة للرئيسية</a>
                </div>
            </div>
        </div>
    );
};

export default Login;
